<template>
    <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 d-flex flex-column align-center justify-center" style="min-height: 100vh; padding-bottom: 0;">
        <div class="glass-card pa-8 text-center animate-fade-in-up stagger-1" style="max-width: 600px; width: 100%;">
            <!-- Logo -->
            <v-img height="50px" class="mb-8" contain src="/img/roodyLogoGreen.png"></v-img>

            <!-- Error Icon Visual -->
            <div class="my-6 d-flex justify-center">
                <div class="d-flex align-center justify-center rounded-circle" style="width: 80px; height: 80px; background: rgba(239, 83, 80, 0.1); border: 3px solid #ef5350;">
                    <v-icon size="40" color="#ef5350">mdi-alert-circle-outline</v-icon>
                </div>
            </div>

            <!-- Error Heading -->
            <h2 class="text-h5 font-weight-black white--text mb-4" style="line-height: 1.3;">
                Zahlung fehlgeschlagen
            </h2>

            <!-- Detailed Message -->
            <p class="grey--text text--lighten-1 mb-6" style="font-size: 0.95rem; line-height: 1.6; text-align: left;">
                Keine Sorge, es wurde kein Betrag abgebucht. Bitte überprüfe deine Zahlungsinformationen und versuche es erneut. <br/><br/>
                Du wirst in Kürze automatisch zurück zum Warenkorb geleitet, um den Zahlungsvorgang fortzusetzen. Solltest du weitere Unterstützung benötigen, stehen wir dir gerne zur Verfügung.
            </p>

            <!-- Back Action Button -->
            <v-card-actions class="justify-center px-0 py-0">
                <v-btn class="premium-btn py-6 px-8" block @click="$router.push('/shop/checkout')">
                    <v-icon left>mdi-cart-arrow-right</v-icon>
                    Zurück zum Warenkorb
                </v-btn>
            </v-card-actions>
        </div>
    </div>
</template>
  
<script>
export default {
    async created() {
        setTimeout(async () => {
            this.$router.push('/shop/checkout')
        }, 10000)
    },
}
</script>

<style>
@import './shopCommon.css';
</style>

  